import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	SHARE: {
		path: 'share',
		method: 'POST'
	}
};

export interface IShareWishlistOptions extends IBaseFetchOptions {
	body: {
		languageCode?: string;
		countryCode?: string;
		senderName: string;
		senderEmail: string;
		recipientEmail: string;
		message: string;
	};
}

export interface IShareWishlistResponse extends IBaseResponse {
	message: string;
}
